// import React from 'react';

import React, { useState } from 'react'
import { Button, Typography, Divider, Box, Stack } from '@mui/material';
import ScrollBox from '../../../components/ScrollBox';
import BackButton from '../../../components/BackButton';
import ProductReqCard from '../../../components/ProductReqCard';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import BgBoxOld from '../../../components/BgBoxOld';
import { Add } from '@mui/icons-material';
import { useQuery, useQueryClient } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { createProdReqServ, editCartServ, getCartListServ } from '../../../services/prodreq-service';
import { useEffect } from 'react';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';

function CreateProdReqPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient()
  const { setLoadingScreen, ctxtUser, setAsyncLoading } = useAuthContext();
  const [formErrors, setFormErrors] = useState({});
  const { isLoading, isError, error, data: cartData } = useQuery([QueryKey.cartList, ctxtUser?.userId], () => getCartListServ(), {
    refetchOnMount: true,
    refetchOnWindowFocus: false
  });
  const location = useLocation();
  const [selProds, setSelProds] = useState([])

  useEffect(() => {
    setLoadingScreen(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);


  useEffect(() => {
    if (!cartData)
      return

    if (!cartData?.cartArr)
      return;

    setSelProds(cartData?.cartArr)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData]);


  useEffect(() => {
    queryClient.invalidateQueries([QueryKey.comUserProfile]);
    return () => queryClient.invalidateQueries([QueryKey.comUserProfile]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);


  async function updateCartData(data) {
    setAsyncLoading(true);
    try {
      const payload = data.map((i) => ({ amtcProdIdStrg: i?.amtcProdIdStrg, qty: i?.qty }))
      await editCartServ(payload);
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setAsyncLoading(false);
  }


  async function handleQuantityChange(prodIndex, qty) {
    const updatedProducts = [...selProds];
    updatedProducts[prodIndex]['qty'] += qty;
    if (updatedProducts[prodIndex]['qty'] === 0) {
      updatedProducts.splice(prodIndex, 1);
    }
    await updateCartData(updatedProducts);
    setSelProds(updatedProducts);
    queryClient.invalidateQueries();
  };

  async function handleProdRemove(prodIndex) {
    const updatedProducts = [...selProds];
    updatedProducts.splice(prodIndex, 1);

    await updateCartData(updatedProducts);
    setSelProds(updatedProducts);
    queryClient.invalidateQueries();
  };


  async function handleSubmit(e) {
    e.preventDefault();
    if (selProds.length === 0) {
      notify("error", "To Create a Request, Select atleast one product!")
      return;
    }
    const formData = new FormData(e.target);
    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
    let errorsObj = validate(inputObject);
    setFormErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0)
      return;

    setLoadingScreen(true);
    try {
      const payload = {
        deptId: cartData?.deptId,
        description: inputObject.description,
        prodsArr: selProds.map((i) => ({ amtcProdIdStrg: i?.amtcProdIdStrg, qty: i?.qty }))
      }
      const { message } = await createProdReqServ(payload);
      notify("success", message);
      queryClient.invalidateQueries();
      navigate(`${route.cProdreqlist}`, { replace: true })
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setLoadingScreen(false);
  };

  function validate(values) {
    const errors = {};

    // if (!values.projName)
    //     errors.projName = "Project Name is required!";

    return errors;
  };

  function handleAddProdClick() {
    navigate(route.comCataLog)
  }


  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  return (
    <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%", position: "relative" }}>
      <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5}>
        <BackButton />
        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Create Product Request</Typography>
        <Box />
      </Stack>
      <BgBoxOld height={"93%"} py={1}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography sx={{ fontSize: 16, fontWeight: 600 }}>Products</Typography>
          <Button onClick={handleAddProdClick} startIcon={<Add />}
            sx={{ bgcolor: 'white', color: 'rgba(0, 16, 238, 1)', borderRadius: 1.5, boxShadow: 3, width: 150 }}>Add to Request</Button>
        </Box>
        <Divider sx={{ mt: 0.5 }} />

        <ScrollBox height={"50%"}>
          {selProds.map((i, index) => (
            <React.Fragment key={i?.id}>
              <ProductReqCard i={i} onQuantityChange={handleQuantityChange} onRemove={handleProdRemove} index={index} />
              {index < selProds.length - 1 && <Divider sx={{ py: 0.2 }} />}
            </React.Fragment>
          ))}
        </ScrollBox>
        <LabelTxtFieldInfo name="description" title="Remarks" width={"100%"} height={100} borderRadius={1} rows={4} multiline={true} />
      </BgBoxOld>

      <Box sx={{ position: "absolute", bottom: 20, right: 20 }}>
        <Button variant="contained" type='submit' sx={{
          borderRadius: 1, backgroundColor: "rgba(255, 183, 3, 1)", fontSize: 14, color: "rgba(7, 42, 200, 1)"
        }} >
          CREATE REQUEST
        </Button>
      </Box>
    </form>
  );
}

export default CreateProdReqPage;